import { SettingKey } from '@dto/settings.dto';
import { UserDTO } from '@dto/usersResponse.dto';
import { getSettings } from 'src/service/settings.service';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface UsersStoreState {
  // State
  selectedUserId: string | null;
  selectedUserData: UserDTO | null;
  isCreateUserMode: boolean;
  isUserModalOpen: boolean;
  defaultTimezone: string;
}

interface UsersStoreActions {
  // Actions
  setSelectedUserId: (id: string) => void;
  setSelectedUserData: (data: UserDTO) => void;
  setIsCreateUserMode: (isCreate: boolean) => void;
  setIsUserModalOpen: (isOpen: boolean) => void;
  setDefaultTimezone: (tz: string) => void;

  // Thunks
  fetchDefaultTimezone: () => Promise<void>;
}

export const USERS_INITIAL_STATE: UsersStoreState = {
  // State
  selectedUserId: null,
  selectedUserData: null,
  isCreateUserMode: false,
  isUserModalOpen: false,
  defaultTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
};

export const useUsersStore = create<UsersStoreState & UsersStoreActions>()(
  devtools((set) => ({
    // State
    ...USERS_INITIAL_STATE,
    // Actions
    setSelectedUserId: (id) => set({ selectedUserId: id }),
    setSelectedUserData: (data) => set({ selectedUserData: data }),
    setIsCreateUserMode: (isCreate) => set({ isCreateUserMode: isCreate }),
    setIsUserModalOpen: (isOpen) => set({ isUserModalOpen: isOpen }),
    setDefaultTimezone: (tz) => set({ defaultTimezone: tz }),

    // Thunks
    fetchDefaultTimezone: async () => {
      const keys = SettingKey.GLOB;
      try {
        const resp = await getSettings(keys.PREFIX);
        const settings = resp.data.data;
        keys.reType(settings);

        if (settings.GLOB_DEFAULT_TIMEZONE) {
          set({ defaultTimezone: settings.GLOB_DEFAULT_TIMEZONE });
        }
      } catch (error) {
        console.error('Failed to fetch default timezone:', error);
      }
    },
  }))
);
